import React, {useContext, useState, useEffect} from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
//import { AuthContext } from "../../context/AuthContext";
import { ToastContainer } from 'react-toastify';
//import "bootstrap/dist/css/bootstrap.css";
import "./../../Public/css/tabler-icons.css";
import "./../../Public/css/fontawesome.min.css";
import "./../../Public/css/all.min.css";
import "./../../Public/css/style.css";
import logo from "./../../Public/img/logo-black.png";

import {errorMesg} from "./../Toaster";
import {userLoginAPI} from "./../../API/AuthenticationAPI";
import { useAuth } from "../../context/AuthContext";


const Signin = () =>{

    //const {user, setUser, loading} = useContext(AuthContext);
    const {user, setUser, loading, setToken} = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [btnloading, setBtnLoading] = useState(false);
    

    

    useEffect(() =>{

        console.log('I am in sign in');

        //const token = localStorage.getItem('cpmstoken');
        const token = sessionStorage.getItem('cpmstoken');
        let userinfo = localStorage.getItem('userinfo');

        //console.log(token);

        //console.log(token +'&&'+ userinfo +'&&'+ !loading +'&&'+ location.pathname);

        if(token && userinfo && !loading && ((location.pathname === "/sign-in") || (location.pathname === "/")))
        {
            console.log('Logged in system');

            //localStorage.removeItem('userinfo');

            const userdata = JSON.parse(userinfo);

            //console.log('role id====' + userdata.role_id);
            if(location.pathname === "/sign-in" && userdata.role_id === 1)
            {
                navigate('/admin/dashboard');
            }
            else if(location.pathname === "/sign-in" && userdata.role_id === 2)
            {
                navigate('/sales/dashboard');
            }
            else if(location.pathname === "/sign-in" && userdata.role_id === 3)
            {
                navigate('/caller/dashboard');
            }
            else if(location.pathname === "/sign-in" && userdata.role_id === 4)
            {
                navigate('/team/dashboard');
            }
            else if(location.pathname === "/sign-in" && userdata.role_id === 5)
            {
                navigate('/vendor/dashboard');
            }
            else
            {
                navigate('/sign-in');
            }
            
        }


    }, [user, loading, location, navigate]);

    if (loading) return <p>Checking auth...</p>;

    const handleSetUsername = (event) =>{
        setUsername(event.target.value);
    }

    const handleSetPassword = (event) =>{
        setPassword(event.target.value);
    }

    const handleSignInSubmit = (event) =>{
        event.preventDefault();
        
        if(username === "")
        {
            //alert('c');
            errorMesg("Please enter your username");
        }
        else if(password === "")
        {
            errorMesg("Please enter your password");
        }
        else
        {
            const params = {
                            username: username,
                            password: password,
                        };

            userLoginAPI(params, setBtnLoading, navigate, setUser, setToken);
        }
    }

    console.log('dsasdd');

    return(
        <div className="account-page">
            <div className="main-wrapper">
                <div className="account-content">
                    <div className="w-100 vh-100 overflow-hidden auth-wrapper basic-auth">
                        <div className="auth-inner">
                            <div className="card__wrapper overflow-auto">
                                <form action="#" className="flex-fill">
                                    <div className="mx-auto mw-450">
                                        <div className="text-center mb-4 img-logo">
                                            <img src={logo} className="img-fluid" alt="Logo" />
                                        </div>
                                        <div className="mb-4 text-center">
                                            <h4 className="mb-2 fs-20">Sign In</h4>                                            
                                        </div>
                                        <div className="mb-3">
                                            <label className="col-form-label">Username</label>
                                            <div className="position-relative">
                                                <span className="input-icon-addon">
                                                    <i className="ti ti-user"></i>
                                                </span>
                                                <input type="text" name="username" id="username" className="form-control" value={username} onChange={handleSetUsername} autoComplete="off" />
                                            </div>
                                        </div>
                                        <div className="mb-3">
                                            <label className="col-form-label">Password</label>
                                            <div className="pass-group">
                                                <input type="password" className="pass-input form-control" name="passwd" id="passwd" value={password} onChange={handleSetPassword}  autoComplete="off" />
                                                <span className="ti toggle-password ti-eye-off"></span>
                                            </div>
                                        </div>

                                        <div className="d-flex align-items-center justify-content-between mb-3">

                                            <div className="form-check form-check-md d-flex align-items-center">

                                                {/*<input className="form-check-input" type="checkbox" value="" id="checkebox-md" checked="" />

                                                <label className="form-check-label" for="checkebox-md"> Remember Me </label>*/}
                                            </div>

                                            <div className="text-end">

                                                <Link to="/forgot-password" className="text-primary fw-medium link-hover">Forgot Password </Link>
                                            </div>
                                        </div>

                                        <div className="mb-3">
                                            <button type="button" className="btn btn-primary w-100"  onClick={handleSignInSubmit}>
                                                {btnloading ?
                                                    <div className="spinner-border" role="status">
                                                        <span className="sr-only">Loading...</span>
                                                    </div>
                                                :
                                                    <p>Sign in</p>
                                                }
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <ToastContainer />

            </div>
        </div>
    )
}

export default Signin;